"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setIf = exports.setIn = exports.push = exports.set = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _freeze = _interopRequireDefault(require("./freeze"));

var set = function set(name, value) {
  return function (obj) {
    obj = (0, _extends2.default)({}, obj);
    obj[name] = value;
    return obj;
  };
};

exports.set = set;

var push = function push(name, value) {
  return function (obj) {
    return set(name, [].concat((0, _toConsumableArray2.default)(obj[name] || []), [value]))(obj);
  };
};

exports.push = push;

var defaultForPath = function defaultForPath(path) {
  return typeof path[0] === 'string' || path[0] instanceof String || (0, _typeof2.default)(path[0]) === 'symbol' ? (0, _freeze.default)({}) : (0, _freeze.default)([]);
};

var setIn = function setIn(path, value) {
  return function () {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultForPath(path);
    return path.length === 1 ? set(path[0], value)(obj) : set(path[0], setIn(path.slice(1), value)(obj[path[0]]))(obj);
  };
};

exports.setIn = setIn;

var resolvePredicate = function resolvePredicate(predicate, options) {
  return typeof predicate === 'function' ? predicate(options) : predicate;
};

var getValue = function getValue(v) {
  return typeof v === 'function' ? v() : v;
};

var setIf = function setIf(predicate, propertyName, valueOrFn) {
  return function (obj) {
    return resolvePredicate(predicate, obj) ? set(propertyName, getValue(valueOrFn))(obj) : obj;
  };
};

exports.setIf = setIf;